/* eslint-disable react/require-default-props */
import React from 'react';
import { bool, func, node, oneOf, string } from 'prop-types';
import { GLOBAL } from '@Config/global';
import './styles.scss';

const InformationModal = ({
  icon = 'bi bi-exclamation-circle',
  status = 'success',
  onConfirm,
  onClose,
  confirmText = 'Aceptar',
  showConfirm = true,
  message = 'Información',
  title = 'Información'
}) => {
  const getIconColor = () => {
    switch (status) {
      case 'warning':
        return '#ffc107';
      case 'error':
        return '#dc3545';
      case 'success':
        return '#28a745';
      default:
        return '#007bff';
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0 justify-content-end">
            <button
              type="button"
              className="btn-close"
              onClick={onClose || onConfirm}
              aria-label="Close"
            />
          </div>

          <div className="modal-body text-center">
            {status === 'warning' && (
              <div className="mb-3">
                <i className={icon} style={{ fontSize: '3rem', color: getIconColor() }}></i>
              </div>
            )}

            {status === 'error' && (
              <div className="mb-3">
                <i className={icon} style={{ fontSize: '3rem', color: getIconColor() }}></i>
              </div>
            )}

            {status === 'success' && (
              <div className="mb-3">
                <i className='bi bi-info-circle' style={{ fontSize: '3rem', color: getIconColor() }}></i>
              </div>
            )}

            <h5 className="modal-title mb-3">{title}</h5>
            <p className="text-secondary">{message}</p>
          </div>

          {showConfirm && (
            <div className="modal-footer border-0 d-flex justify-content-center">
              <button
                type="button"
                className={`btn btn-primary`}
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

InformationModal.propTypes = {
  onConfirm: func.isRequired,
  onClose: func,
  confirmText: string,
  showConfirm: bool,
  message: node,
  title: string,
  status: oneOf(['primary', 'warning', 'error', 'success']),
  icon: string
};



export default InformationModal;
